import Vue from 'vue';
import Vuex from 'vuex';
import { drawerStore } from './DrawerStore';
import { DishesStore } from './DishesStore';
import notificationsStore from './NotificationsStore';
import userInfoStore from './UserInfoStore';
import defaultValuesStore from './DefaultValuesStore';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    drawerStore,
    dishesStore: DishesStore,
    notificationsStore,
    userInfoStore,
    defaultValuesStore,
  },
});
